import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// Components
import Router from "../../../../router";
import { StatusCell } from "../../statusCell";
import TableModelScroll from "../../tables/TableModelScroll";

// Styles
import { ContainersButtonsGroup, CustomButtonV2, ModalFooter, ModalHeader, ModalSubHeader } from "../../../../pages/styles"
import { Body, Container, ContainerButtonCreate } from "./styles"


export const AssetWorkflowsModalCard = ({ loading, data, handleCloseWorkflow }) => {

    const { t } = useTranslation();
    const navigate = useNavigate()

    const headers = [
        {
            id: 'code',
            label: 'asset.workflowTable.id',
            center: true,
            disablePadding: true,
            sortArrow: true,
            type: 'link',
            onClick: linkComponent
        },
        {
            id: 'status',
            label: 'asset.workflowTable.status',
            center: false,
            disablePadding: true,
            sortArrow: true,
            type: 'custom',
            customSort: "workflowStatus?.title"
        },
        {
            id: 'title',
            label: 'asset.workflowTable.title',
            center: false,
            disablePadding: true,
            sortArrow: true,
            isRender: true,
        },
        {
            id: 'plant',
            label: 'asset.workflowTable.plant',
            center: false,
            disablePadding: true,
            sortArrow: true,
            type: 'object',
            keys: ['name'],
            customSort: "plant?.name"
        },
        {
            id: 'contract',
            label: 'asset.workflowTable.contract',
            center: false,
            disablePadding: true,
            sortArrow: true,
            type: 'object',
            keys: ['code'],
            customSort: "contract?.code"
        },
        {
            id: 'updatedAt',
            label: 'asset.workflowTable.lastUpdate',
            center: false,
            disablePadding: true,
            sortArrow: true,
            type: 'shortDate',
        },
    ];

    function linkComponent(row) {
        navigate(Router.appWorkflowDetail.replace(':workflowId', row.workflowId).replace(':id', row.id),
            { state: { row: row, workflow: row.workflow, from: Router.appAssetList } }
        )
    }

    function statusCellComponent(workflowStatus) {
        if (workflowStatus) return <StatusCell workflowStatus={workflowStatus} showType={false} />
        return <div></div>
    }

    return (
        <Container>
            <ModalHeader>{t('asset.workflowData')}</ModalHeader>
            <ModalSubHeader/>
            <Body sx={{ px: 2 }}>
                <TableModelScroll
                    headers={headers}
                    filteredRequest={data}
                    rows={data}
                    hideFilterDate={true}
                    hideToolbar={true}
                    defaultRowsPerPage={25}
                    custom={statusCellComponent}
                    defaultSort={'createdAt'}
                    loadingData={loading}
                />
            </Body>
            <ModalFooter>
                <ContainersButtonsGroup sx={{ pb: 0 }}>
                    <ContainerButtonCreate>
                        <CustomButtonV2
                            aria-label="close"
                            btnType="cancel"
                            onClick={handleCloseWorkflow}
                        >
                            {t('common.close')}
                        </CustomButtonV2>
                    </ContainerButtonCreate>
                </ContainersButtonsGroup>
            </ModalFooter>
        </Container>
    )
}